import React, { useState, useRef, useEffect } from 'react';
import { FaThumbsUp, FaThumbsDown, FaEye } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { useAuth } from '../../AuthContext';
import { Overlay, Tooltip } from 'react-bootstrap';
import '../../styles/components/common/InteractionButtons.css';

function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'm';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  }
  return num.toString();
}

const InteractionButtons = ({
  userInteraction,
  handleLike,
  handleDislike,
  interactionLoading,
  likeCount,
  dislikeCount,
  viewCount,
}) => {
  const { user } = useAuth();
  const [showLoginInfoLike, setShowLoginInfoLike] = useState(false);
  const [showLoginInfoDislike, setShowLoginInfoDislike] = useState(false);
  const likeWrapperRef = useRef(null);
  const dislikeWrapperRef = useRef(null);

  const onLikeClick = () => {
    if (!user) {
      setShowLoginInfoLike(true);
    } else {
      handleLike();
    }
  };

  const onDislikeClick = () => {
    if (!user) {
      setShowLoginInfoDislike(true);
    } else {
      handleDislike();
    }
  };

  useEffect(() => {
    if (showLoginInfoLike) {
      const handleClickOutside = (event) => {
        if (likeWrapperRef.current && !likeWrapperRef.current.contains(event.target)) {
          setShowLoginInfoLike(false);
        }
      };
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [showLoginInfoLike]);

  useEffect(() => {
    if (showLoginInfoDislike) {
      const handleClickOutside = (event) => {
        if (dislikeWrapperRef.current && !dislikeWrapperRef.current.contains(event.target)) {
          setShowLoginInfoDislike(false);
        }
      };
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [showLoginInfoDislike]);

  return (
    <div className="interaction-buttons">
      <div className="interaction-wrapper" ref={likeWrapperRef}>
        <button
          onClick={onLikeClick}
          className={`interaction-item like-button ${userInteraction === 'like' ? 'active' : ''}`}
          disabled={interactionLoading}
        >
          <FaThumbsUp className="action-icon" />
          <span className="interaction-count">{formatNumber(likeCount || 0)}</span>
        </button>
        <Overlay target={likeWrapperRef.current} show={showLoginInfoLike} placement="bottom">
          {(props) => (
            <Tooltip id="login-tooltip-like" {...props} className="login-tooltip">
              Please login to use
            </Tooltip>
          )}
        </Overlay>
      </div>
      <div className="interaction-wrapper" ref={dislikeWrapperRef}>
        <button
          onClick={onDislikeClick}
          className={`interaction-item dislike-button ${userInteraction === 'dislike' ? 'active' : ''}`}
          disabled={interactionLoading}
        >
          <FaThumbsDown className="action-icon" />
          <span className="interaction-count">{formatNumber(dislikeCount || 0)}</span>
        </button>
        <Overlay target={dislikeWrapperRef.current} show={showLoginInfoDislike} placement="bottom">
          {(props) => (
            <Tooltip id="login-tooltip-dislike" {...props} className="login-tooltip">
              Please login to use
            </Tooltip>
          )}
        </Overlay>
      </div>
      <div className="interaction-item view-item">
        <FaEye className="action-icon" />
        <span className="interaction-count">{formatNumber(viewCount || 0)}</span>
      </div>
    </div>
  );
};

InteractionButtons.propTypes = {
  userInteraction: PropTypes.oneOf(['like', 'dislike', null]),
  handleLike: PropTypes.func.isRequired,
  handleDislike: PropTypes.func.isRequired,
  interactionLoading: PropTypes.bool.isRequired,
  likeCount: PropTypes.number,
  dislikeCount: PropTypes.number,
  viewCount: PropTypes.number,
};

export default InteractionButtons;
